<div [class]="classes().root">
  @for (group of groups(); track $index; let last = $last) {
    <div [class]="classes().group" aria-hidden="true">
      @for (index of group; track index) {
        <span
          [class]="
            focused() && index === activeIndex() && !verifying()
              ? classes().boxActive
              : classes().box
          "
          [style.animation-delay.ms]="verifying() ? index * waveStepMs : null">
          <!-- re-created per digit, so each one fades in as it is typed -->
          @if (value().charAt(index); as digit) {
            <span [class]="classes().digit">{{ digit }}</span>
          }
        </span>
      }
    </div>
    @if (!last) {
      <span class="w-2 text-center text-zinc-500" aria-hidden="true">-</span>
    }
  }
  <!-- the one real input, stretched invisibly over the boxes -->
  <input
    #field
    [class]="classes().field"
    type="text"
    inputmode="numeric"
    autocomplete="one-time-code"
    pattern="[0-9]*"
    [attr.maxlength]="length()"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-invalid]="invalid() || null"
    [disabled]="isDisabled()"
    [value]="value()"
    (input)="handleInput($event)"
    (focus)="handleFocus()"
    (blur)="handleBlur()" />
</div>
